import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useGetAllUsersQuery } from "slices/usersApi";
import { useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useDeleteBeauticianMutation } from "slices/beautyApp/beauticianSlice";
import axios from "axios";

function Users() {
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [dateError, setDateError] = useState("");

  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [openeduser, setOpeneduser] = useState(null);
  const auth = useSelector((state) => state.auth.auth?.user);
  const [del] = useDeleteBeauticianMutation();
  const { data, isLoading, error, refetch } = useGetAllUsersQuery({
    page,
    limit,
    search,
    startDate,
    endDate,
  });

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const formatPrettyDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  };

  const makeconnection = async (id) => {
    if (window.confirm(`"Making connection with user ID:", ${id}`)) {
      const adminToken = localStorage.getItem("adminf");
      const response = await axios.post(
        `https://betaapi.madamg.ai/api/backend/v1/auth/set-access`,
        { id: id, type: "home" },
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 30000,
        },
      );

      if (response.data.success) {
        const { token, user, redirectUrl } = response.data;
        console.log("Impersonation successful:", {
          token: token.substring(0, 20) + "...",
          user,
        });
        window.open(redirectUrl, "_blank");
      } else {
        throw new Error(response.data.error || "Impersonation failed");
      }
    }
  };

  const col = [
    { display: "Mobile", key: "mobile", type: "display" },
    { display: "Name", key: "name", type: "display" },
    { display: "Email", key: "email", type: "display" },
    { display: "Gender", key: "gender", type: "display" },
    { display: "Register From", key: "regFrom", type: "display" },
    {
      display: "Register Date",
      key: "created",
      type: "display",
      render: (row) => formatPrettyDateTime(row.created),
    },
    {
      display: "Place-Order",
      key: "edit",
      type: "action",
      render: (row, onEdit) => {
        const hasAccess =
          auth?.role !== "staff" ||
          auth?.modules?.some((m) => m.name === "Users");

        return (
          <>
            <Button
              onClick={() => {
                makeconnection(row._id);
              }}
            >
              Select
            </Button>
          </>
        );
      },
    },
    {
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit) => {
        const hasAccess =
          auth?.role !== "staff" ||
          auth?.modules?.some((m) => m.name === "Users");

        return (
          <>
            {hasAccess && <Button onClick={() => onEdit(row)}>View</Button>}
            <Button
              onClick={() => {
                handleDelete(row._id);
              }}
            >
              Delete
            </Button>
          </>
        );
      },
    },
  ];
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };
  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1;
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setOpeneduser(row);
    setOpen(true);
  };

  const setClose = () => {
    setOpeneduser(null);
    setOpen(false);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 2,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          {/* Start Date */}
          <TextField
            type="date"
            size="small"
            label="Start Date"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              setEndDate("");
              setPage(1);
              setDateError("");
            }}
            inputProps={{
              max: new Date().toISOString().split("T")[0],
            }}
            error={!!dateError}
            sx={{ minWidth: 170 }}
          />

          <TextField
            type="date"
            size="small"
            label="End Date"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              setPage(1);
              setDateError("");
            }}
            inputProps={{
              min: startDate || "",
            }}
            error={!!dateError}
            sx={{ minWidth: 170 }}
          />

          <Button
            variant="contained"
            size="small"
            onClick={() => {
              if (startDate && new Date(startDate) > new Date()) {
                setDateError("Start date cannot be in future");
                return;
              }

              if (
                startDate &&
                endDate &&
                new Date(endDate) < new Date(startDate)
              ) {
                setDateError("End date must be after start date");
                return;
              }

              setDateError("");
              refetch();
            }}
          >
            Apply
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setStartDate("");
              setEndDate("");
              setDateError("");
              setPage(1);
            }}
          >
            Clear
          </Button>
        </Box>
        {dateError && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <span style={{ color: "red", fontSize: "13px" }}>{dateError}</span>
          </Box>
        )}
      </div>
      <Tables
        title={"Users"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
